"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayersOverview = exports.getCurrentPlayerIndex = void 0;
const vue_1 = require("vue");
const PlayerInfo_1 = require("./PlayerInfo");
const OverviewSettings_1 = require("./OverviewSettings");
const OtherPlayer_1 = require("../OtherPlayer");
const ActionLabel_1 = require("./ActionLabel");
const AutomaBotInfo_1 = require("./AutomaBotInfo");
const Phase_1 = require("../../Phase");
const getCurrentPlayerIndex = (player, players) => {
    let currentPlayerIndex = 0;
    players.forEach((p, index) => {
        if (p.color === player.color) {
            currentPlayerIndex = index;
        }
    });
    return currentPlayerIndex;
};
exports.getCurrentPlayerIndex = getCurrentPlayerIndex;
exports.PlayersOverview = vue_1.default.component('players-overview', {
    props: {
        player: {
            type: Object,
        },
    },
    components: {
        'player-info': PlayerInfo_1.PlayerInfo,
        'overview-settings': OverviewSettings_1.OverviewSettings,
        'other-player': OtherPlayer_1.OtherPlayer,
        'automa-bot-info': AutomaBotInfo_1.AutomaBotInfo,
    },
    data: function () {
        return {
            componentKey: 0,
        };
    },
    methods: {
        hasPlayers: function () {
            return this.player.players.length > 0;
        },
        getPlayerOnFocus: function () {
            return this.player.players.filter((p) => p.color === this.player.color)[0];
        },
        getIsFirstForGen: function (player) {
            return exports.getCurrentPlayerIndex(player, this.player.players) === 0;
        },
        getPlayersInOrder: function () {
            const players = this.player.players;
            let result = [];
            let currentPlayerOffset = 0;
            const currentPlayerIndex = exports.getCurrentPlayerIndex(this.player, this.player.players);
            currentPlayerOffset = currentPlayerIndex + 1;
            result = players
                .slice(currentPlayerOffset)
                .concat(players.slice(0, currentPlayerOffset));
            return result.slice(0, -1);
        },
        getActionLabel(player) {
            if (player.hasConceded)
                return ActionLabel_1.ActionLabel.CONCEDED;
            if (this.player.phase === Phase_1.Phase.DRAFTING) {
                if (!this.player.draftedPlayers.includes(player.color))
                    return ActionLabel_1.ActionLabel.DRAFTING;
                return ActionLabel_1.ActionLabel.NONE;
            }
            if (this.player.phase === Phase_1.Phase.RESEARCH) {
                if (!this.player.researchedPlayers.includes(player.color))
                    return ActionLabel_1.ActionLabel.RESEARCHING;
                return ActionLabel_1.ActionLabel.NONE;
            }
            if (this.player.passedPlayers.includes(player.color))
                return ActionLabel_1.ActionLabel.PASSED;
            if (player.isActive)
                return ActionLabel_1.ActionLabel.ACTIVE;
            return ActionLabel_1.ActionLabel.NONE;
        },
    },
    created: function () {
        this.$root.$on('updatePlayersOverview', (_e) => {
            this.componentKey += 1;
        });
    },
    template: `
        <div class="players-overview" v-if="hasPlayers()" :key="componentKey">
            <overview-settings />
            <div class="other_player" v-if="player.players.length > 1">
                <div v-for="(otherPlayer, index) in getPlayersInOrder()" :key="otherPlayer.id">
                    <other-player v-if="otherPlayer.id !== player.id" :player="otherPlayer" :playerIndex="index"/>
                </div>
            </div>

            <player-info v-for="(p, index) in getPlayersInOrder()" :activePlayer="player" :player="p"  :key="p.id" :firstForGen="getIsFirstForGen(p)" :actionLabel="getActionLabel(p)" :playerIndex="index"/>
            <player-info :player="getPlayerOnFocus()" :activePlayer="player" :key="player.players.length - 1" :firstForGen="getIsFirstForGen(player)" :actionLabel="getActionLabel(player)" :playerIndex="-1"/>

            <div v-if="player.players.length === 1 && player.gameOptions.automaSoloVariant">
                <automa-bot-info :player="player"/>
            </div>
        </div>
    `,
});
//# sourceMappingURL=PlayersOverview.js.map